import type { FeatureGroup } from '../../../../types';
import { DEVELOPMENT_FEATURE_GROUP } from '../group';

export const DEVELOPMENT_LINK2PAY_FEATURE_GROUP: FeatureGroup = {
  guid: '0dc6cde0-5ed1-4307-89a4-05749fecff00',
  name: 'development:link2pay',
  description: 'Link2Pay development tool — generate payment links',
  product: 'app',
  parentGuid: DEVELOPMENT_FEATURE_GROUP.guid,
};
